import React from 'react';
import PropTypes from 'prop-types';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import { DEFAULT_HEADER_HEIGHT, headerBoundsPropType } from 'common/src/app/data/layout';
import './affix-container.scss';
import ComponentType from 'common/src/app/data/enum/ComponentType';

type HeaderBounds = {
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
  width?: number;
  height?: number;
};

type AffixContainerProps = {
  headerBounds?: HeaderBounds;
  children?: React.ReactNode;
};

const AffixContainer = (
  { children, headerBounds }: AffixContainerProps,
  _context: unknown,
  className?: string,
): JSX.Element => (
  <div
    className={className}
    style={{
      top: `${headerBounds?.height ?? DEFAULT_HEADER_HEIGHT}px`,
      maxHeight: `calc(100vh - ${headerBounds?.height ?? DEFAULT_HEADER_HEIGHT}px)`,
    }}
  >
    {children}
  </div>
);

AffixContainer.propTypes = {
  headerBounds: headerBoundsPropType,
  children: PropTypes.node,
};

export default withFunctionalClassName(ComponentType.MOLECULE, 'AffixContainer')(AffixContainer);
